var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserDefault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 173,
    height: 173,
    viewBox: "0 0 173 173",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12733 23879)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4150 -1481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.5,0C165.255,0,173,7.745,173,86.5S165.255,173,86.5,173,0,165.255,0,86.5,7.745,0,86.5,0Z",
    transform: "translate(-8583 -22398)",
    fill: "#fff",
    opacity: 0.73
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5,0C165.255,0,173,7.745,173,86.5S165.255,173,86.5,173,0,165.255,0,86.5,7.745,0,86.5,0Z",
    transform: "translate(-8583 -22398)",
    fill: "#91b850",
    opacity: 0.73
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48.12,54.135A27.068,27.068,0,1,0,21.053,27.068,27.075,27.075,0,0,0,48.12,54.135ZM72.18,60.15H61.823a32.721,32.721,0,0,1-27.406,0H24.06A24.058,24.058,0,0,0,0,84.21v3.008A9.025,9.025,0,0,0,9.023,96.24h78.2a9.025,9.025,0,0,0,9.023-9.023V84.21A24.058,24.058,0,0,0,72.18,60.15Z",
    transform: "translate(-12695.08 -23841.08)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDefault);
export default __webpack_public_path__ + "static/media/user-default.950a772dff1820b1aeea3fb276b186d6.svg";
export { ForwardRef as ReactComponent };